import { IKnmPlanFilterRaw } from 'APIPackage/PlanListModule/interfaces/IKnmPlanFilterRaw';
import { DATE_FORMAT_ISO_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IKnmPlanFilter } from 'PlanListPackage/PlanListFiltersModule/interfaces/IKnmPlanFilter';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';

export function mapPlanFilterToRaw(data: IKnmPlanFilter): IKnmPlanFilterRaw {
  const startDate = formatDate({ date: data.startDate, dateFormat: DATE_FORMAT_ISO_FNS });
  const endDate = formatDate({ date: data.endDate, dateFormat: DATE_FORMAT_ISO_FNS });

  return {
    ...data,
    id: data.id ? Number(data.id) : null,
    knoIds: data.knoIds?.map(x => x.idStr?.toString() ?? '').filter(Boolean) ?? [],
    knoErvkUuids:
      data.knoIds
        ?.map(knoId => (knoId?.value as { dictVersionId: string } | undefined)?.dictVersionId?.toString())
        .filter((id): id is string => id !== undefined) || [],
    prosecutorOrganizationErvkUuids:
      data.prosecutorOrganizationErvkUuids?.length > 0
        ? data.prosecutorOrganizationErvkUuids?.map(x => x.id.toString())
        : [],
    types: data.types?.length > 0 ? data.types?.map(x => x.value) : [],
    statuses: data.statuses?.map(x => x.id.toString()),
    erknmStatuses: data.erknmStatuses?.map(x => x.id.toString()),
    startDate,
    endDate,
    isDefault: false,
    isTest: data.isTest?.value,
  };
}
